import { useMutation } from "react-query";
import { bulkUploadCustomerToPosition } from "../Services/Dashboard/tableGridService";

export const useBulkUploadCustomers = () => {
    const { data, isLoading, isError, error, mutate } = useMutation(
    (customerData) => bulkUploadCustomerToPosition({
      input: {
        customerToPositionCode: customerData || []
      }
    })
  );

  return {
    data,
    isLoading,
    isError,
    error,
    bulkUploadCustomers: mutate
  }
};

export default useBulkUploadCustomers;
